import { Col, Row, Checkbox } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import GeneralBloc from "../../../../bloc/general_bloc";
import ProfileBloc from "../../../../bloc/profile_bloc";
import RouteBloc from "../../../../bloc/route_bloc";
import App_header from "../../../component/app_header/app_header";
import App_header_title_simple from "../../../component/app_header_title/app_header_title_simple";
import Base_screen from "../../base/base_screen/base_screen";
import UserAccessBloc from "../../../../bloc/user_access_bloc";
import HomeBloc from "../../../../bloc/home_bloc";
import Config from "../../../../Config";

import "./proposal_form.css";
import AppStandardDetailsCard from "../../../component/app_quotation_card/app_standard_details_card";
import AppCollapse from "../../../component/app_collapse/app_collapse";
import AppBottomBar from "../../../component/app_bottom_bar/app_bottom_bar";
import AppLoadingDialog from "../../../dialog/app_loading_dialog";
import AppModal from "../../../component/app_modal/app_modal";
import ProposalBloc from "../../../../bloc/mrtt_proposal_bloc";
import AppGeneratedDocumentsDetailsCard from "../../../component/app_quotation_card/app_generated_documents_card2";
import moment from "moment";
import AppSteps from "../../../component/app_steps/app_steps2";

class ReviewDetails extends Component {
    constructor(props) {
        super(props);
        let routeParams = RouteBloc.extractRouteParamsFromProps(props);
        this.state = {
            route: routeParams,
            client: Config.context,
            userDataHeader: null,
            userSettings: {},
            stepHeader: [
                {
                    title: 'Provide Details',
                    status: 'process'
                },
                {
                    title: 'Upload Documents',
                    status: 'process'
                },
                {
                    title: 'Review',
                    status: 'process'
                },
                {
                    title: 'Consent and Declaration',
                    status: 'wait'
                },
            ],
        };
    }

    getProposalID() {
        return this.props.match.params.itemId;
    }

    getUserDataHeader() {
        return this.state.userDataHeader;
    }
    getUserData() {
        return this.state.userData;
    }

    getEntity() {
        return this.state.route.entity;
    }

    getUserSettings() {
        return this.state.userSettings;
    }

    generateProfileSettingValue() {
        let userSettings = this.getUserSettings().info[0].value;
        let userData = this.getUserData();
        let value = userData[userSettings];
        return value;
    }

    componentDidMount() {
    }

    async getFormData() {
        this.setState({ loading: true });
        let userData = await UserAccessBloc.getUserData();
        let userSettings = await UserAccessBloc.getUserSettings();
        let name = "";
        let role = "";
        let branch = "";
        let profile = [];
        if (userData) {
            name = userData ? userData.displayName : "";
            role = userData ? userData.designationTitle : "";
            profile = userSettings ? userSettings.module.profile : [];
            this.setState({
                userData: userData,
                userDataHeader: HomeBloc.getUserData(name, role, branch),
                userSettings: profile,
            });
        }
        let result = await ProposalBloc.getProposalDetail(this.getProposalID(), userData.username); //'SHA002'
        this.setState({ formDetails: result, loading: false });
    }

    stateFormDetails() {
        return this.state.formDetails;
    }

    companyNameByEntity = () => {
        if (this.props.userGlobal) {
            switch (this.props.userGlobal.roles[0].entity) {
                case Config.entity.hsbc.code:
                    return "HSBC Amanah";
                case Config.entity.alliance.code:
                    return "Alliance Islamic Bank Berhad";
                case Config.entity.mbsb.code:
                    return "MBSB Bank Berhad";
                default:
                    return null;
            }
        }

    }

    handleGoBackToDashboard = () => {
        return window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.home}`
    }

    handleGoBackStep = () => {
        return window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal_upload_documents}/${this.getProposalID()}`
    }

    handleStopWithoutSaving = () => {
        return window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal}`
    }

    handleSaveCurrentStep() {
        return window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal}`
    }

    async handleNextStep() {
        this.setState({ loading: true });
        let generateProposalResult = await ProposalBloc.generateProposalForm(this.getProposalID());
        if (generateProposalResult.success) {
            this.setState({ loading: false });
            window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal_consent_declaration}/${this.getProposalID()}`;
        } else {
            this.setState({
                loading: false,
                isOpen: true,
                title: 'Error',
                description: generateProposalResult.message
            })
        }
    }

    handleFormSubmit() {
    }

    handleMessageModalOpen = () => {
        this.setState({ isOpen: true })
    }
    handleMessageModalClose = () => {
        this.setState({ isOpen: false })
    }

    handleSaveModalOpen = () => {
        this.setState({ isSaveModalOpen: true })
    }
    handleSaveModalClose = () => {
        this.setState({ isSaveModalOpen: false })
    }

    handleDiscardModalOpen = () => {
        this.setState({ isDiscardModalOpen: true })
    }
    handleDiscardModalClose = () => {
        this.setState({ isDiscardModalOpen: false })
    }

    getInitial(name) {
        let result = GeneralBloc.mergeIntoInitialName(name);
        return result;
    }

    renderTableHeader() {
        return (
            <div className="mt-3">
                <div className="row d-flex m-0 table-header-container align-items-center ">
                    <div className="" style={{ width: '4%' }}>Yes</div>
                    <div className="" style={{ width: '4%' }}>No</div>
                    <div className="" style={{ width: '23%' }}>Medical Condition</div>
                    <div className="" style={{ width: '12%' }}>Date of Diagnosis</div>
                    <div className="" style={{ width: '20%' }}>Treatment Prescribed</div>
                    <div className="" style={{ width: '14%' }}>Attending Doctor{'\''}s Name</div>
                    <div className="" style={{ width: '18%' }}>Attending Doctor{'\''}s Address </div>
                </div>
            </div>
        )
    }

    renderTableBody(data) {
        return (
            <div className="row d-flex m-0 align-items-center table-body-container app-standard-content-field-content">
                <div className="" style={{ width: '4%' }}>
                    <Checkbox
                        className={'disabledCheckedBox disabledTick'}
                        disabled
                        checked={data.checked == 'Yes'}
                    />
                </div>
                <div className="" style={{ width: '4%' }}>
                    <Checkbox
                        className="disabledCheckedBox disabledTick"
                        disabled
                        checked={data.checked == 'No'}
                    />
                </div>
                <div className="" style={{ width: '23%' }}>
                    {data?.condition}
                </div>
                <div className="" style={{ width: '12%' }}>
                    {data?.dateOfDiagnosis && moment(data?.dateOfDiagnosis).format('DD/MM/YYYY')}
                </div>
                <div className="pt-1" style={{ width: '20%' }}>
                    {data?.treatment}
                </div>
                <div className="pt-1" style={{ width: '14%' }}>
                    {data?.doctorName}
                </div>
                <div className="pt-1" style={{ width: '18%' }}>
                    {data?.doctorAddress}
                </div>
            </div>
        )
    }

    renderExtendedHealthData(data) {
        return (
            <>
                <Row className=''>
                    <Col className="col-lg-6 col-sm-12 mb-4">
                        <div className="app-content-field-tag">{data.q1.caption}</div>
                        <div className="app-standard-content-field-content">{data.q1.value}</div>
                    </Col>
                    <Col className="col-lg-6 col-sm-12 mb-4">
                        <div className="app-content-field-tag">{data.q2.caption}</div>
                        <div className="app-standard-content-field-content"> {data.q2.value}</div>
                    </Col>

                </Row>
                <Row className='mb-4'>
                    <Col className="col-lg-12 col-sm-12">
                        <div className="app-content-field-tag">{data.q3.caption}</div>
                        <div className="app-standard-content-field-content">{data.q3.value}</div>
                    </Col>
                </Row>
                <Row className="mb-4">
                    <Col className="col-lg-12 col-sm-12">
                        <div className="app-content-field-tag">{data.q4.caption}</div>
                        <div className="mt-2">
                            {this.renderTableHeader()}
                            {
                                data?.q4 && data.q4.value.map((item) => {
                                    return (
                                        this.renderTableBody(item)
                                    )
                                })
                            }
                        </div>
                    </Col>
                </Row>
                <Row className="mb-4">
                    <Col className="col-lg-12 col-sm-12">
                        <div className="app-content-field-tag">{data.q5.caption}</div>
                        <div className="mt-2">
                            {this.renderTableHeader()}
                            {
                                data?.q5 && data.q5.value.map((item) => {
                                    return (
                                        this.renderTableBody(item)
                                    )
                                })
                            }
                        </div>
                    </Col>
                </Row>
                <Row className="ml-0 mb-4">
                    <Col className="col-lg-12 col-sm-12">
                        <div className="app-content-field-tag">{data.q6.caption}</div>
                        <div className="mt-2">
                            {this.renderTableHeader()}
                            {
                                data?.q6 && data.q6.value.map((item) => {
                                    return (
                                        this.renderTableBody(item)
                                    )
                                })
                            }
                        </div>
                    </Col>
                </Row>
                <Row className="ml-0 mb-4">
                    <Col className="col-lg-12 col-sm-12">
                        <div className="app-content-field-tag">{data.q7.caption}</div>
                        <div className="mt-2">
                            {this.renderTableHeader()}
                            {
                                data?.q7 && data.q7.value.map((item) => {
                                    return (
                                        this.renderTableBody(item)
                                    )
                                })
                            }
                        </div>
                    </Col>
                </Row>
                <Row className="ml-0">
                    <Col className="col-lg-12 col-sm-12 mb-3">
                        <div className="app-content-field-tag">{data.q8.caption}</div>
                        <div className="mt-2">
                            {data.q8.value}
                        </div>
                    </Col>
                    {
                        data?.q8 && data.q8.value == 'Yes' &&
                        <Col className="col-lg-12 col-sm-12 ml-3 mb-4">
                            <div className="app-content-field-tag">{data.q8a.caption}</div>
                            <div className="mt-2">
                                {data.q8a.value + ' months'}
                            </div>
                        </Col>
                    }

                </Row>
            </>
        )
    }

    renderBottomBar = () => {
        return (
            <AppBottomBar
                enable={true}
                lableDiscard={'Discard'}
                lableSaveAndClose={'Save & Close'}
                lableNext={'Next'}
                alignContent={"right"}
                buttonWidth={"auto"}
                onNext={(e) => { this.handleNextStep() }}
                onDiscard={(e) => this.handleDiscardModalOpen()}
                onSaveAndClose={(e) => this.handleSaveModalOpen()}
            />
        )
    }

    loadingContent() {
        return (
            <div style={{ height: "100%", width: "100%" }}>
                <AppLoadingDialog isLoading={this.state.loading} />
            </div>
        );
    }

    render() {
        return (
            <>
                <Base_screen
                    listener={() => {
                        this.getEntity();
                        this.getFormData();
                    }}
                >
                    <>
                        <App_header
                            data={this.getUserDataHeader()}
                            route={this.getEntity()}
                        >
                            <div style={{ width: '60%' }}>
                                <AppSteps
                                    direction="horizontal"
                                    current={0}
                                    items={this.state.stepHeader}
                                />
                            </div>

                        </App_header>
                        {this.state.loading && this.loadingContent()}
                        <div
                            style={{
                                marginTop: 110,
                                paddingLeft: 42,
                                paddingRight: 42,
                                paddingBottom: 150,
                            }}
                        >
                            <div className="row m-0 w-100">
                                <App_header_title_simple
                                    title={Config.proposal.formStepData[2].header}
                                    description={Config.proposal.formStepData[2].subheader}
                                    handleBack={() => this.handleGoBackStep()}
                                />
                            </div>
                            <div className="w-100 my-2 d-flex row" >
                                <div className="w-100 px-3 " style={{ fontFamily: 'Lato' }}>
                                    {this.stateFormDetails()?.personalDetails && !GeneralBloc.isObjectEmpty(this.stateFormDetails()?.personalDetails) && (
                                        <AppStandardDetailsCard
                                            data={this.stateFormDetails().personalDetails}
                                            fields={
                                                Config.proposal.dataDetailMapping.personalDetails ||
                                                []
                                            }
                                            header={Config.proposal.formDataMapping.step1.personalDetailsTitle}
                                        />
                                    )}
                                    {this.stateFormDetails()?.mortgageDetails && !GeneralBloc.isObjectEmpty(this.stateFormDetails()?.mortgageDetails) && (
                                        <AppStandardDetailsCard
                                            data={this.stateFormDetails().mortgageDetails}
                                            fields={
                                                Config.proposal.dataDetailMapping.mortgageDetails ||
                                                []
                                            }
                                            header={Config.proposal.formDataMapping.step1.mortgageDetailsTitle}
                                        />
                                    )}
                                    {this.stateFormDetails()?.creditCardPayment && !GeneralBloc.isObjectEmpty(this.stateFormDetails()?.creditCardPayment) && (
                                        <AppStandardDetailsCard
                                            data={this.stateFormDetails().creditCardPayment}
                                            fields={
                                                Config.proposal.dataDetailMapping.creditCardPayment ||
                                                []
                                            }
                                            header={Config.proposal.formDataMapping.step1.creditCardDetailsTitle}
                                        />
                                    )}
                                    {this.stateFormDetails()?.healthStatement && !GeneralBloc.isObjectEmpty(this.stateFormDetails()?.healthStatement) && (
                                        <AppStandardDetailsCard
                                            data={this.stateFormDetails().healthStatement}
                                            fields={
                                                Config.proposal.dataDetailMapping.healthStatement ||
                                                []
                                            }
                                            header={Config.proposal.formDataMapping.step1.healthStatementTitle}
                                        />
                                    )}
                                    {this.stateFormDetails()?.directCredit && !GeneralBloc.isObjectEmpty(this.stateFormDetails()?.directCredit) && (
                                        <AppStandardDetailsCard
                                            data={this.stateFormDetails().directCredit}
                                            fields={
                                                Config.proposal.dataDetailMapping.directCreditDetails ||
                                                []
                                            }
                                            header={Config.proposal.formDataMapping.step1.directCreditDetailsTitle}
                                        />
                                    )}
                                    {this.stateFormDetails()?.payorInformation && !GeneralBloc.isObjectEmpty(this.stateFormDetails()?.payorInformation) && (
                                        <AppStandardDetailsCard
                                            data={this.stateFormDetails().payorInformation}
                                            fields={
                                                Config.proposal.dataDetailMapping.payorInformation ||
                                                []
                                            }
                                            header={Config.proposal.formDataMapping.step1.payorInformationTitle}
                                        />
                                    )}
                                    {this.stateFormDetails()?.extendedHealthDetails && !GeneralBloc.isObjectEmpty(this.stateFormDetails()?.extendedHealthDetails) && (
                                        <>
                                            <AppCollapse
                                                header={Config.proposal.formDataMapping.step1.extendedHealthDeclarationTitle}
                                            >
                                                {this.renderExtendedHealthData(this.stateFormDetails()?.extendedHealthDetails)}
                                            </AppCollapse>
                                        </>

                                    )}
                                    {this.stateFormDetails()?.foreignerDetails && !GeneralBloc.isObjectEmpty(this.stateFormDetails()?.foreignerDetails) && (
                                        <AppStandardDetailsCard
                                            data={this.stateFormDetails().foreignerDetails}
                                            fields={
                                                Config.proposal.dataDetailMapping.foreigner ||
                                                []
                                            }
                                            header={Config.proposal.formDataMapping.step1.foreignQuestionaireTitle}
                                        />
                                    )}
                                    {this.stateFormDetails()?.generalOccDetails && !GeneralBloc.isObjectEmpty(this.stateFormDetails()?.generalOccDetails) && (
                                        <AppStandardDetailsCard
                                            data={this.stateFormDetails().generalOccDetails}
                                            fields={
                                                Config.proposal.dataDetailMapping.generalOcc ||
                                                []
                                            }
                                            header={Config.proposal.formDataMapping.step1.generalOccupationTitle}
                                        />
                                    )}
                                    {this.stateFormDetails()?.oilGasDetails && !GeneralBloc.isObjectEmpty(this.stateFormDetails()?.oilGasDetails) && (
                                        <AppStandardDetailsCard
                                            data={this.stateFormDetails().oilGasDetails}
                                            fields={
                                                Config.proposal.dataDetailMapping.oilAndGasOcc ||
                                                []
                                            }
                                            header={Config.proposal.formDataMapping.step1.oilGasTitle}
                                        />
                                    )}
                                    {this.stateFormDetails()?.resTravelDetails && !GeneralBloc.isObjectEmpty(this.stateFormDetails()?.resTravelDetails) && (
                                        <AppStandardDetailsCard
                                            data={this.stateFormDetails().resTravelDetails}
                                            fields={
                                                Config.proposal.dataDetailMapping.residentialForeignTravel ||
                                                []
                                            }
                                            header={Config.proposal.formDataMapping.step1.residentailForeignTravelTitle}
                                        />
                                    )}
                                    {/* <AppCollapse
                                header={'Generated Document'}
                            > */}
                                    {this.stateFormDetails()?.generatedDocuments && (
                                        <AppGeneratedDocumentsDetailsCard
                                            title={'Uploaded Documents'}
                                            module={'proposal'}
                                            data={this.stateFormDetails().generatedDocuments}
                                        />
                                    )}
                                    {/* </AppCollapse> */}

                                    {this.renderBottomBar()}
                                    <AppModal
                                        open={this.state.isSaveModalOpen}
                                        handleModalClose={this.handleSaveModalClose}
                                        width={'50%'}
                                        title={'Do you want to stop?'}
                                        subtitle={'If you stop without saving, you will loose any progress you’ve made.'}
                                        negativeButtonText={'Stop without Saving'}
                                        positiveButtonText={'Save & Close'}
                                        handleNegativePress={() => this.handleStopWithoutSaving()}
                                        handlePositivePress={() => this.handleSaveCurrentStep()}
                                        closable={false}
                                    />
                                    <AppModal
                                        open={this.state.isDiscardModalOpen}
                                        handleModalClose={this.handleDiscardModalClose}
                                        width={'50%'}
                                        title={'Do you want to discard?'}
                                        subtitle={'If you discard without saving, you will loose any progress you’ve made.'}
                                        negativeButtonText={'Stop without Saving'}
                                        positiveButtonText={'Save & Close'}
                                        handleNegativePress={() => this.handleStopWithoutSaving()}
                                        handlePositivePress={() => this.handleSaveCurrentStep()}
                                        closable={false}
                                    />
                                    <AppModal
                                        open={this.state.isOpen}
                                        handleModalClose={() => this.handleMessageModalClose()}
                                        width={'50%'}
                                        title={this.state.title}
                                        subtitle={this.state.description}
                                        positiveButtonText={'Close'}
                                        handlePositivePress={() => this.handleMessageModalClose()}
                                        closable={false}
                                    />
                                </div>
                            </div>

                        </div>
                    </>
                </Base_screen>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    userGlobal: state.user.value,
    globalFilterBy: state.filter.value,
    globalSearchBy: state.searchBy.value,
    userConfigGlobal: state.userConfig.value,
});

export default withRouter(connect(mapStateToProps)(ReviewDetails));
